import React, { useCallback } from 'react'
import { Form, Input, Button } from 'antd'
import { connect } from 'dva'
import PageWrapper from '@/components/PageWrapper'
import './Team.module.less'

const layout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 16 },
}

const CreateTeam = ({ dispatch, baseInfo, changeTeamStatus }) => {
  const onFinish = useCallback(
    (values) => {
      const formData = new FormData()
      Object.keys(values).forEach((key) => {
        const v = values[key]
        if (v) {
          formData.append(key, values[key])
        }
      })
      dispatch({
        type: 'center/createTeam',
        payload: {
          params: formData,
        },
      })
    },
    [dispatch]
  )

  return (
    <PageWrapper
      style={{ marginTop: '45px' }}
      subTitle={<span styleName="title">创建团队</span>}
    >
      <Form
        {...layout}
        name="basic"
        labelAlign="left"
        initialValues={{
          phone: baseInfo.phone,
          qq: baseInfo.qq,
        }}
        onFinish={onFinish}
        style={{ marginTop: '30px' }}
      >
        <Form.Item
          label="团队名称"
          name="name"
          rules={[{ required: true, message: '请输入团队名称' }]}
        >
          <Input styleName="input" placeholder="请输入团队名称" />
        </Form.Item>
        <Form.Item
          label="队长电话"
          name="leaderPhone"
          rules={[{ required: true, message: '请输入队长电话' }]}
        >
          <Input styleName="input" placeholder="请输入队长电话" />
        </Form.Item>
        <Form.Item className="align-left-label" label="联系QQ" name="leaderQq">
          <Input styleName="input" placeholder="请输入联系QQ号码" />
        </Form.Item>
        <div styleName="tips">
          注：一个账号只允许创建/加入一个团队，请在个人中心填写准确联系方式以便联系以及奖励发放
        </div>
        <div style={{ marginTop: '50px' }} styleName="content">
          <Button
            style={{ marginRight: '100px', width: '88px' }}
            type="primary"
            htmlType="submit"
          >
            提交审核
          </Button>
          <Button
            style={{ width: '88px' }}
            onClick={() => changeTeamStatus('table')}
          >
            取 消
          </Button>
        </div>
      </Form>
    </PageWrapper>
  )
}

export default connect(({ center }) => {
  return {
    teamPagination: center.teamPagination,
    baseInfo: center.baseInfo,
  }
})(CreateTeam)
